import { pathWithReturnTo, safeReturnPath } from './authReturn'

// Where a signed-out visitor goes (REG-398): /login, so the address bar says
// where they are, carrying the page they wanted as ?next= so sign-in returns
// them there. The return path is validated like every other one in the auth
// flow: only an application path survives.
export function loginPathFor(pathname: string, search: string): string {
  return pathWithReturnTo('/login', safeReturnPath(pathname + search))
}

// A signed-in visitor on /login has nothing to do there, so they are sent on,
// unless the address carries something the login page must act on (a password
// reset, a sign-in handoff, a setup link, an error to show). Only a bare
// /login, or one with just ?next=, counts as "nothing to do".
export function isPlainLoginVisit(search: string): boolean {
  const keys = Array.from(new URLSearchParams(search).keys())
  return keys.every((k) => k === 'next')
}
